import isEmpty from "lodash.isempty"

export type IndividualState = "init"|"registed"|"arrived"|"accepted"|"rejected"|"dismantled"|"processing"|"processed"|"nknown"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setIndividualStatus = (formValues: any) => {
  if (isEmpty(formValues.status)) return { ...formValues, status: "init" }
  switch (formValues.status) {
    case "init":
      return { ...formValues, status: "registed" }
    case "registed":
      if (formValues.arrivalDatetime) return { ...formValues, status: "arrived" }
      return { ...formValues, status: "nknown" }
    case "arrived":
      if (formValues.acceptability === "可") {
        return { ...formValues, status: "accepted" }
      } else if (formValues.acceptability === "不可") {
        return { ...formValues, status: "rejected" }
      }
      return formValues
    case "accepted":
      if (formValues.acceptability === "不可") {
        return { ...formValues, status: "rejected" }
      }
      if (formValues.demolitionDate) {
        return { ...formValues, status: "dismantled" }
      }
      return formValues
    case "dismantled":
      if (formValues.processingDate) {
        return { ...formValues, status: "processed" }
      }
      if (formValues.processingStartDate) {
        return { ...formValues, status: "processing" }
      }
      return formValues
    case "processing":
      if (formValues.processingDate) {
        return { ...formValues, status: "processed" }
      }
      return formValues
    default:
      return formValues
  }
}

export const products = [
  "枝肉",
  "ステーキ[ヒレ]",
  "ステーキ[ロース]",
  "ステーキ[モモ]",
  "鹿串[モモ]",
  "ロース（ボーンレストリップ）",
  "ロース（ロングロイン）",
  "ロース",
  "ヒレ",
  "ショルダー",
  "バラ",
  "内モモ",
  "外モモ",
  "シンタマ",
  "ランプ",
  "シキンボ",
  "モモ",
  "ネック",
  "スネ",
  "ハラミ",
  "タン",
  "ハート",
  "レバー",
  "ミンチ"
]
